require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./tooltip"));
	else if(typeof define === 'function' && define.amd)
		define(["./tooltip"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./tooltip")) : factory(root["./tooltip"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__16__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[38],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-multilinetruncatedtext{display:inline-block;vertical-align:top}", ""]);

// exports
exports.locals = {
	"multilinetruncatedtextClassName": "\"ba-multilinetruncatedtext\""
};

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__16__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

module.exports = require("react-measure");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(388);


/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Multilinetruncatedtext = _interopRequireDefault(__webpack_require__(389));

exports.default = _Multilinetruncatedtext.default;
exports.Multilinetruncatedtext = _Multilinetruncatedtext.default;

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = exports.DEFAULT_DELAY_TIME = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _reactMeasure = _interopRequireDefault(__webpack_require__(29));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _tooltip = _interopRequireDefault(__webpack_require__(16));

var _Multilinetruncatedtext = _interopRequireDefault(__webpack_require__(390));

var _domMeasureHelpers = __webpack_require__(391);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const multilinetruncatedtextClassName = _Multilinetruncatedtext.default.multilinetruncatedtextClassName.replace(/"/g, '');

const DEFAULT_DELAY_TIME = 50;
exports.DEFAULT_DELAY_TIME = DEFAULT_DELAY_TIME;

class Multilinetruncatedtext extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "_updateTextState", (node, textInfo, numLines, width) => {
      const lineWidth = width || node.offsetWidth;
      const info = (0, _domMeasureHelpers.populateText)(lineWidth, numLines, textInfo);
      let disableFlag = false;

      if (this.props.disableTooltip) {
        disableFlag = true;
      } else if (!this.props.disableTooltip && this.props.enforceTooltip) {
        disableFlag = false;
      } else {
        disableFlag = info.disableTooltip;
      }

      return {
        truncatedText: info.text,
        disableTooltip: disableFlag
      };
    });
    (0, _defineProperty2.default)(this, "_resizeHandler", contentRect => {
      this.contentRect = contentRect;
      clearTimeout(this.timeout);

      const calculateTruncatedTextValues = this._calculateTruncatedTextValues.bind(this);

      this.timeout = setTimeout(() => {
        calculateTruncatedTextValues();
      }, DEFAULT_DELAY_TIME);
    });
    this.node = null;
    this.timeout = false;

    this.setNodeRef = element => {
      this.node = element;
    };

    const {
      disableTooltip
    } = this.props; // truncatedText is an array of substrings so intialize it to empty [] until componentDidMount and _resizeHandler calculated
    // the contents of the truncatedText array correctly

    this.state = {
      disableTooltip,
      truncatedText: []
    };
  }

  componentDidMount() {
    this.textInfo = {
      wordLengths: [],
      ellipsisLength: 0,
      style: {
        lineHeight: this.props.style.lineHeight,
        fontInfo: ''
      }
    };
    this.textInfo = (0, _domMeasureHelpers.updateTextInfo)(this.node, this.textInfo, this.props.value, this.props.numLines);

    const updatedState = this._updateTextState(this.node, this.textInfo, this.props.numLines);

    this.setState(updatedState);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this._calculateTruncatedTextValues();
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  /*
   * @description Process and return an array of strings where each string is a substring from original text that has been
   * truncated to fit the allowable space of the this.node in the DOM
   *
   * Example: original string this.props.value = 'Greater than or equal to 220%' with this.props.numLines = 3
   * Base on the avalailable space of this.node 'Greater than or equal to 220%' get split into:
   * this.state.truncatedText = ['Greater than or equal', 'to 220%', ''].
   * this.state.truncatedText get render in the DOM as 3 distinct div:
   * <div>Greater than or equal</div>
   * <div>to 220%</div>
   *
   * @return {string[]} Return truncatedText if truncatedText is an Array of string else calculate the substrings and return []
   */
  _processMultiTruncatedTextValues() {
    const {
      truncatedText
    } = this.state;

    if (typeof truncatedText === 'string') {
      // check this.node to only to call _calculateTruncatedTextValues when the node is mounted int the dom
      // check this.contentRect to only call _calculateTruncatedTextValues after the mode had been resize
      // When truncatedText is a string in 2 cases: during constructor and setState with truncatedText as string
      // In the first case (construction phase) this.node and this.contentRect are set in componentDidMount and _resizeHandler ,
      // both of these functions set truncatedText to be an array of substrings which cause the Component to be re-render
      // For the second case setState({ truncatedText: 'ABCD....'}), this function call _calculateTruncatedTextValues to convert
      // the string to multiline array of substrings. In this case return [] so that nothing get render in the DOM until the
      // multiline substrings had been calculated. This is to avoid rendering
      // <div>A</div>
      // <div>B</div>
      // <div>C</div>
      // <div>....
      // which cause the vertical array of characters to be display and flash on the screen
      this._calculateTruncatedTextValues();

      return [];
    }

    return truncatedText;
  }
  /*
   * @description Convert text value to mulitiline truncated array of strings and update the state.truncatedText
   * to contain the truncated array of string values
   */


  _calculateTruncatedTextValues() {
    // check this.node to only to call _calculateTruncatedTextValues when the node is mounted int the dom
    // check this.contentRect to only call _calculateTruncatedTextValues after the mode had been resize
    if (this.node && this.contentRect) {
      let updatedState = this._updateTextState(this.node, this.textInfo, this.props.numLines, this.contentRect.bounds.width);

      const isHeightEqual = (0, _domMeasureHelpers.checkHeight)(this.contentRect.bounds.height, this.textInfo.style.lineHeight);

      if (!isHeightEqual) {
        this.textInfo = (0, _domMeasureHelpers.updateTextInfo)(this.node, this.textInfo, this.props.value, this.props.numLines);
        updatedState = this._updateTextState(this.node, this.textInfo, this.props.numLines);
      }

      this.setState(updatedState);
    }
  }

  render() {
    const {
      className,
      style,
      value,
      dir,
      tooltipDelay,
      tooltipText
    } = this.props;
    const title = tooltipText || value;
    const text = [];

    const values = this._processMultiTruncatedTextValues();

    for (let i = 0; i < values.length; i++) {
      text.push( /*#__PURE__*/_react.default.createElement("div", {
        key: i
      }, values[i]));
    }

    return /*#__PURE__*/_react.default.createElement(_reactMeasure.default, {
      bounds: true,
      onResize: this._resizeHandler
    }, ({
      measureRef
    }) => /*#__PURE__*/_react.default.createElement("div", {
      className: `${multilinetruncatedtextClassName} ${className}`,
      dir: dir,
      ref: measureRef,
      style: style
    }, /*#__PURE__*/_react.default.createElement("div", {
      ref: this.setNodeRef
    }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      disabled: this.state.disableTooltip,
      delay: tooltipDelay,
      orient: "top",
      style: {
        width: '100%'
      },
      title: title
    }, text))));
  }

}

exports.default = Multilinetruncatedtext;
(0, _defineProperty2.default)(Multilinetruncatedtext, "propTypes", {
  /** Class names to pass in */
  className: _propTypes.default.string,

  /** Disables the tooltip */
  disableTooltip: _propTypes.default.bool,

  /** Number of lines to truncate at */
  numLines: _propTypes.default.number,

  /** Styles to pass in */
  style: _propTypes.default.object,

  /** Direction of the text */
  dir: _propTypes.default.oneOf(['', 'auto', 'rtl', 'ltr']),

  /** Delay before the tooltip appears */
  tooltipDelay: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number]),

  /** text displayed in the tooltip */
  tooltipText: _propTypes.default.string,

  /** Text to truncate */
  value: _propTypes.default.string.isRequired,

  /** Enforce the display of tooltip even the text is not long enough (disableTooltip must be set to false) */
  enforceTooltip: _propTypes.default.bool
});
(0, _defineProperty2.default)(Multilinetruncatedtext, "defaultProps", {
  className: '',
  disableTooltip: false,
  numLines: 1,
  style: {},
  dir: '',
  tooltipText: '',
  value: '',
  enforceTooltip: false
});

/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Multilinetruncatedtext_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(121);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Multilinetruncatedtext_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Multilinetruncatedtext_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Multilinetruncatedtext_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Multilinetruncatedtext_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.checkHeight = exports.hasOverflowed = exports.populateText = exports.removeFirstNElements = exports.populateLine = exports.wordCanFit = exports.populateCharacters = exports.updateTextInfo = exports.getTextInfo = exports.getTextWidth = void 0;

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
// eslint-disable-next-line no-underscore-dangle
const _cachedCanvas = document.createElement('canvas');

const getTextWidth = (textToCal, font, isCharacter) => {
  let text = textToCal;
  if (!isCharacter) text += ' ';

  const context = _cachedCanvas.getContext('2d');

  context.font = font;
  const metrics = context.measureText(text);
  return metrics.width;
};

exports.getTextWidth = getTextWidth;

const getTextInfo = (node, value, numLines) => {
  const words = value.replace(/\s+/g, ' ').trim().split(' ');
  const lengths = [];
  const maxPossibleLength = Math.floor(numLines) * window.innerWidth;
  const cssData = window.getComputedStyle(node, null);
  const fontData = {
    fontSize: cssData.getPropertyValue('font-size'),
    fontFamily: cssData.getPropertyValue('font-family'),
    fontWeight: cssData.getPropertyValue('font-weight')
  };
  let cumulativeLength = 0;

  for (let i = 0; i < words.length; i++) {
    // We want to avoid getting the width of excessively many words.
    if (cumulativeLength < maxPossibleLength) {
      const width = getTextWidth(words[i], `${fontData.fontWeight} ${fontData.fontSize} ${fontData.fontFamily}`);
      lengths.push({
        word: words[i],
        length: width
      });
      cumulativeLength += length;
    } else {
      break;
    }
  }

  const styles = {
    lineHeight: cssData.getPropertyValue('line-height'),
    fontInfo: `${fontData.fontWeight} ${fontData.fontSize} ${fontData.fontFamily}`
  };
  const info = {
    lengths,
    styles
  };
  return info;
};

exports.getTextInfo = getTextInfo;

const updateTextInfo = (node, textInfo, value, numLines) => {
  const word = getTextInfo(node, value, numLines);
  textInfo.wordLengths = word.lengths;
  textInfo.ellipsisLength = getTextWidth('...', word.styles.fontInfo, true);
  textInfo.style = word.styles;
  return textInfo;
};

exports.updateTextInfo = updateTextInfo;

const populateCharacters = (width, word, textInfo) => {
  let currentWidth = 0;
  let text = ' ';
  let i = 0;

  while (i < word.length) {
    // Can make this faster by storing character-width associations somewhere (only 26 letters in the alphabet and 10 digits), but too lazy...
    const letterWidth = getTextWidth(word.charAt(i), textInfo.style.fontInfo, true);

    if (currentWidth + letterWidth < width) {
      text += word.charAt(i);
      currentWidth += letterWidth;
      i += 1;
    } else {
      break;
    }
  }

  return text;
};

exports.populateCharacters = populateCharacters;

const wordCanFit = (i, numWords, currentWidth, wordWidth, isLast, ellipsisLength, lineWidth) => i < numWords && (currentWidth + wordWidth <= lineWidth - (!isLast || i === numWords - 1 ? 0 : ellipsisLength) || !currentWidth && wordWidth > lineWidth);

exports.wordCanFit = wordCanFit;

const populateLine = (lineWidth, textInfo, isLast) => {
  const {
    wordLengths,
    ellipsisLength
  } = textInfo;
  let text = '';
  let currentWidth = 0;
  let i = 0;
  const singleWordOverflow = wordLengths[i] ? wordLengths[i].length > lineWidth : false;

  if (!singleWordOverflow) {
    while (i < wordLengths.length && (currentWidth + wordLengths[i].length < lineWidth - (!isLast || i === wordLengths.length - 1 ? 0 : ellipsisLength) || !currentWidth && wordLengths[i].length > lineWidth)) {
      text = `${text} ${wordLengths[i].word}`;
      currentWidth += wordLengths[i].length;
      i += 1;
    }
  }

  if (i < wordLengths.length && isLast || singleWordOverflow) {
    text += populateCharacters(lineWidth - ellipsisLength - currentWidth, wordLengths[i].word, textInfo);

    if (!isLast && singleWordOverflow) {
      i += 1;
    }
  }

  const info = {
    text,
    index: i,
    singleWordOverflow
  };
  return info;
};

exports.populateLine = populateLine;

const removeFirstNElements = (obj, n) => {
  for (let i = 0; i < n; i++) {
    obj.wordLengths.shift();
  }

  return obj;
};

exports.removeFirstNElements = removeFirstNElements;

const populateText = (lineWidth, numLines, textInfo) => {
  const text = [];
  let textObj = textInfo;
  let containsLineWithTrunc = false;

  for (let i = 0; i < numLines; i++) {
    const lineInfo = populateLine(lineWidth, textObj, i === numLines - 1);
    text.push(i === numLines - 1 ? lineInfo.text.trim() : `${lineInfo.text.trim()} `);

    if (lineInfo.singleWordOverflow && i !== numLines - 1) {
      text[i] = `${text[i].trim()}...`;
      if (!containsLineWithTrunc) containsLineWithTrunc = true;
    }

    textObj = removeFirstNElements(textObj, lineInfo.index);
  }

  const isfinishedDisplaying = textObj.wordLengths.length !== 0;

  if (isfinishedDisplaying) {
    text[numLines - 1] = `${text[numLines - 1].trim()}...`;
  }

  const info = {
    text,
    disableTooltip: !isfinishedDisplaying && !containsLineWithTrunc
  };
  return info;
};

exports.populateText = populateText;

const hasOverflowed = (height, numLines, lineHeight) => height !== numLines * lineHeight;

exports.hasOverflowed = hasOverflowed;

const checkHeight = (height, numLines, lineHeight) => {
  if (lineHeight) {
    const lineHeightValue = lineHeight.substr(0, lineHeight.length - 2);
    const parsedLineHeight = parseInt(lineHeightValue, 10);
    return hasOverflowed(height, numLines, parsedLineHeight);
  }

  return false;
};

exports.checkHeight = checkHeight;

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[387,0]]]);
});